import { ENCRYPT_GUID, ENCRYPT_DNF_GUID } from '../store/schema/EncryptionGUID';
export default function getEncryptionInfoBarMessageId(templateId) {
    switch (templateId) {
        case ENCRYPT_GUID:
            return 'encryption';
        case ENCRYPT_DNF_GUID:
            return 'encryptionDoNotForward';
    }
    return null;
}
//# sourceMappingURL=getEncryptionInfoBarMessageId.js.map